document.addEventListener("DOMContentLoaded", () => {
  /* ▼ タブ切り替え（そのまま） */
  const tabs = document.querySelectorAll(".calendar-tab");
  const months = document.querySelectorAll(".calendar-month");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.dataset.target;
      months.forEach(m => {
        m.classList.remove("active");
        if (m.id === target) m.classList.add("active");
      });
    });
  });

  /* ▼ Live配信リンクを押したらポップアップを出さない */
  document.addEventListener("click", (e) => {
    const liveLink = e.target.closest(".live-btn a");
    if (!liveLink) return;
    e.stopPropagation();
  });

  /* ▼ スマホのときだけポップアップ */
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  const events = document.querySelectorAll(".event");
  events.forEach(ev => {
    ev.addEventListener("click", () => {
      // PCなら何もしない（=ポップアップ出さない）
      if (!isMobile()) return;

      const title = ev.dataset.title;
      const time = ev.dataset.time;
      const url = ev.dataset.url || "";

      const popup = document.createElement("div");
      popup.className = "event-popup";

      const liveBtnHtml = url
        ? `<div class="live-btn"><a href="${url}" target="_blank" rel="noopener">Live配信へ</a></div>`
        : "";

      popup.innerHTML = `
        <div class="event-popup-content">
          <h3>${title}</h3>
          <p>${time}</p>
          ${liveBtnHtml}
          <div class="event-popup-close">閉じる</div>
        </div>
      `;

      document.body.appendChild(popup);

      popup.querySelector(".event-popup-close").addEventListener("click", () => {
        popup.remove();
      });

      // 背景クリックでも閉じる（任意だけど便利）
      popup.addEventListener("click", (e) => {
        if (e.target === popup) popup.remove();
      });
    });
  });
});
